__turbopack_context__.v({
  "active": "xamM4W_active",
  "buttonRowsWrapper": "xamM4W_buttonRowsWrapper",
  "content": "xamM4W_content",
  "fadeIn": "xamM4W_fadeIn",
  "fadeOut": "xamM4W_fadeOut",
  "left": "xamM4W_left",
  "right": "xamM4W_right",
  "root": "xamM4W_root",
  "scrollButton": "xamM4W_scrollButton",
});
